import React, { useState } from 'react';
import { addDocument } from '../services/firestoreService';
import { Box, Typography, Button, Snackbar, Alert, Paper } from '@mui/material';
import SalesImporter from '../components/SalesImporter';
import ManageSales from '../components/settings/ManageSales';
import DiagnosisImporter from '../components/DiagnosisImporter';
import ProcedureImporter from '../components/ProcedureImporter';
import PatientsImporter from '../components/PatientsImporter';
import OwnersImporter from '../components/OwnersImporter';

const Admin = () => {
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const dogBreeds = [
    'Mestizo', 'Labrador Retriever', 'Golden Retriever', 'Pastor Alemán', 'Poodle (Caniche)',
    'Bulldog Francés', 'Bulldog Inglés', 'Pug', 'Salchicha (Teckel)', 'Yorkshire Terrier',
    'Schnauzer', 'Cocker Spaniel', 'Bichón Frisé', 'Chihuahua', 'Shih Tzu', 'Beagle',
    'Border Collie', 'Siberian Husky', 'Boxer', 'Rottweiler', 'Doberman', 'Gran Danés',
    'Dalmatian', 'Pitbull Terrier Americano', 'Bull Terrier', 'Fila Brasileño', 'Akita Inu',
    'Shiba Inu', 'Samoyedo', 'Corgi', 'Jack Russell Terrier', 'West Highland White Terrier (Westie)',
    'Fox Terrier (Pelo Liso, Pelo Duro)', 'Setter Irlandés/Inglés', 'Braco Alemán', 'Pointer Inglés',
    'Vizsla', 'Basset Hound', 'Galgo', 'San Bernardo'
  ];

  const handleSeedDogBreeds = async () => {
    setLoading(true);
    try {
      for (const breed of dogBreeds) {
        await addDocument('dog_breeds', { name: breed });
      }
      setSnackbar({ open: true, message: 'La colección de razas de perros ha sido creada con éxito.', severity: 'success' });
    } catch (error) {
      console.error('Error al poblar la colección de razas:', error);
      setSnackbar({ open: true, message: 'Error al crear la colección. Revisa la consola.', severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom>
        Panel de Administración
      </Typography>
      <Typography variant="body1">
        Esta página solo es accesible para usuarios con el rol de 'admin'.
      </Typography>
      <Box mt={4}>
        <Typography variant="h6">Sembrado de Colecciones</Typography>
        <Button 
          variant="contained" 
          onClick={handleSeedDogBreeds} 
          disabled={loading}
          sx={{ mt: 2 }}
        >
          {loading ? 'Poblando...' : 'Poblar Colección de Razas de Perros'}
        </Button>
        <Typography variant="caption" display="block" mt={1}>Esta acción llenará la base de datos con una lista predefinida de razas de perros. Ejecútala solo una vez.</Typography>
      </Box>

      <Box mt={4}>
        <Typography variant="h6" gutterBottom>
          Importar Ventas Reales
        </Typography>
        <SalesImporter />
      </Box>

      <Box mt={4}>
        <ManageSales />
      </Box>

      <Box mt={4}>
        <DiagnosisImporter />
      </Box>

      <Box mt={4}>
        <ProcedureImporter />
      </Box>

      <Box mt={4}>
        <PatientsImporter />
      </Box>

      <Box mt={4}>
        <OwnersImporter />
      </Box>

      <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default Admin;
